import React, { useCallback, useEffect, useState } from 'react';

interface ProviderLogoProps {
  name: string;
  path?: string;
  url?: string;
}

const PUBLIC_ASSET_DOMAIN = 'https://public.meter.com'; // TODO: Dynamic based on ENV

export default function ProviderLogo({ name, path = '', url = '' }: ProviderLogoProps) {
  const [showImage, setShowImage] = useState(true);

  const publicAssetUrl = path.length ? PUBLIC_ASSET_DOMAIN + path : undefined;
  const assetUrl = url.length ? url : publicAssetUrl;

  useEffect(() => {
    setShowImage(true);
  }, [path]);
  const onError = useCallback(() => {
    setShowImage(false);
  }, []);

  if (showImage && assetUrl) {
    return (
      <img
        src={assetUrl}
        alt={name}
        title={`Logo of ${name}`}
        onError={onError}
        style={{
          maxHeight: '28px',
        }}
      />
    );
  }
  return <span>{name}</span>;
}
